export enum CountryEN {
    POLAND = "Poland",
    SPAIN = "Spain"
}
